import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

export function getDatepickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDatepickerConfig(), {
    containerClass: 'theme-red'
  } as BsDatepickerConfig);
}